module.exports = __webpack_public_path__ + "img/MePoint-loading.gif";